import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="policy-page">
      <Header />
      <div className="policy-container">
        <h1 className="policy-title">Terms of Service</h1>
        <p className="policy-date">Last updated: April 2026</p>

        <div className="policy-content">
          <section className="policy-section">
            <h3 className="section-title">1. Agreement to Terms</h3>
            <p className="section-text">
              By accessing and using the Liiskerlane website and services, you
              agree to be bound by these Terms of Service. If you do not agree
              to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">2. Use License</h3>
            <p className="section-text">
              Permission is granted to temporarily download one copy of the
              materials (information or software) on Liiskerlane's website for
              personal, non-commercial transitory viewing only. This is the
              grant of a license, not a transfer of title, and under this
              license you may not:
            </p>
            <ul className="section-list">
              <li>Modify or copy the materials</li>
              <li>
                Use the materials for any commercial purpose or for any public
                display
              </li>
              <li>
                Attempt to decompile or reverse engineer any software contained
                on the website
              </li>
              <li>
                Remove any copyright or other proprietary notations from the
                materials
              </li>
              <li>
                Transfer the materials to another person or "mirror" the
                materials on any other server
              </li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
          </section>

          <section className="policy-section">
            <h3 className="section-title">3. Disclaimer</h3>
            <p className="section-text">
              The materials on Liiskerlane's website are provided on an 'as is'
              basis. Liiskerlane makes no warranties, expressed or implied, and
              hereby disclaims and negates all other warranties including,
              without limitation, implied warranties or conditions of
              merchantability, fitness for a particular purpose, or
              non-infringement of intellectual property or other violation of
              rights.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">4. Limitations</h3>
            <p className="section-text">
              In no event shall Liiskerlane or its suppliers be liable for any
              damages (including, without limitation, damages for loss of data
              or profit, or due to business interruption) arising out of the use
              or inability to use the materials on Liiskerlane's website, even
              if Liiskerlane or an authorized representative has been notified
              orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">5. Accuracy of Materials</h3>
            <p className="section-text">
              The materials appearing on Liiskerlane's website could include
              technical, typographical, or photographic errors. Liiskerlane does
              not warrant that any of the materials on its website are accurate,
              complete, or current. Liiskerlane may make changes to the
              materials contained on its website at any time without notice.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">6. Links</h3>
            <p className="section-text">
              Liiskerlane has not reviewed all of the sites linked to its
              website and is not responsible for the contents of any such linked
              site. The inclusion of any link does not imply endorsement by
              Liiskerlane of the site. Use of any such linked website is at the
              user's own risk.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">7. Modifications</h3>
            <p className="section-text">
              Liiskerlane may revise these terms of service for its website at
              any time without notice. By using this website, you are agreeing
              to be bound by the then current version of these terms of service.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">8. Governing Law</h3>
            <p className="section-text">
              These terms and conditions are governed by and construed in
              accordance with the laws of the United States, and you irrevocably
              submit to the exclusive jurisdiction of the courts in that
              location.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">9. Product Information</h3>
            <p className="section-text">
              We strive to provide accurate product descriptions and pricing.
              However, we do not warrant that product descriptions, pricing, or
              other content of any materials on our website is accurate,
              complete, reliable, current, or error-free. If a product offered
              by Liiskerlane is not as described, your sole remedy is to return
              it in unused condition.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">10. User Accounts</h3>
            <p className="section-text">
              If you create an account on our website, you are responsible for
              maintaining the confidentiality of your account information and
              password. You agree to accept responsibility for all activities
              that occur under your account. You must notify us immediately of
              any unauthorized use of your account.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">11. Prohibited Conduct</h3>
            <p className="section-text">
              You agree not to engage in any of the following prohibited
              activities:
            </p>
            <ul className="section-list">
              <li>
                Harassing or causing distress or inconvenience to any person
              </li>
              <li>Obscene or abusive language or content</li>
              <li>Disrupting the normal flow of dialogue within our website</li>
              <li>Attempting to gain unauthorized access to our systems</li>
              <li>Transmitting viruses or any other malicious code</li>
              <li>Spamming or sending unsolicited messages</li>
            </ul>
          </section>

          <section className="policy-section">
            <h3 className="section-title">12. Contact Us</h3>
            <p className="section-text">
              If you have any questions about these Terms of Service, please
              contact us at:
            </p>
            <div className="contact-info">
              <p>
                <strong>Email:</strong> trade@liiskerlane.digital
              </p>
              <p>
                <strong>Mailing Address:</strong> Liiskerlane, 19 Bridport Ave,
                Singapore 559309
              </p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
